import * as React from 'react';
import {useState} from "react";

export const ScrollTopButton = () => {
    const [showButton, setShowButton] = useState(false);

    const scrollTop = (event: { preventDefault: () => void; }) => {
        event.preventDefault();
        document.documentElement.style.scrollBehavior = "smooth";
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    const handleScroll = () => {
        if (
            document.body.scrollTop > 20 ||
            document.documentElement.scrollTop > 20
        ) {
            setShowButton(true);
        } else {
            setShowButton(false);
        }
    };

    React.useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
                <button id="scrollToTop" className={showButton ? "show" : "hide"} type={"submit"} value={'test'}
                        onClick={scrollTop}><i className={"arrowUp"}></i></button>
        </>
    );
}
